"use client";

import { FlaskConical } from "lucide-react";
import { Badge } from "@super-resume-new/ui/components/badge";
import { Tooltip, TooltipTrigger, TooltipPopup } from "@super-resume-new/ui/components/tooltip";
import { cn } from "@super-resume-new/ui/lib/utils";

interface ExperimentalBadgeProps {
  className?: string;
  text?: string;
  tooltipText?: string;
}

export function ExperimentalBadge({
  className,
  text = "Experimental",
  tooltipText = "These features are currently in beta testing and may be unstable.",
}: ExperimentalBadgeProps) {
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <span className="inline-flex items-center cursor-help">
            <Badge
              variant="outline"
              className={cn(
                "bg-amber-500/10 text-amber-500 border-amber-500/30 text-[10px] font-semibold px-1.5 py-0.5 rounded-full flex items-center gap-1 hover:bg-amber-500/20 transition-colors",
                className,
              )}
            >
              <FlaskConical className="size-2.5" />
              {text}
            </Badge>
          </span>
        }
      />
      <TooltipPopup
        side="top"
        sideOffset={6}
        className="max-w-xs text-xs text-center leading-snug py-1.5 px-2.5 shadow-sm bg-popover text-popover-foreground border border-border"
      >
        {tooltipText}
      </TooltipPopup>
    </Tooltip>
  );
}
